@if (loading) {
  <div class="d-flex justify-content-center align-items-center h-100">
    <ix-spinner></ix-spinner>
  </div>
} @else if (isHandoverDocumentation) {
  <app-handover-documentation [passportName]="passportName"></app-handover-documentation>
} @else {
  <app-public-generic-submodel-viewer></app-public-generic-submodel-viewer>
}
